if (!customElements.get("cart-upsell-form")) {
  customElements.define(
    "cart-upsell-form",
    class CartUpsellForm extends HTMLElement {
      constructor() {
        super();

        if (this.querySelector("form") != null) {
          this.form = this.querySelector("form");
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
          this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer") ||
            document.querySelector("deployer-cart-drawer");
          this.submitButton = this.querySelector('[type="submit"]');
          if (document.querySelector("cart-drawer")) this.submitButton.setAttribute("aria-haspopup", "dialog");
        }
      }

      renderCart(cart, response) {
        if (typeof cart.renderCartContents === 'function') {
          cart.renderCartContents(response);
        } else if (typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        } else {
          console.error('Une erreur est survenue lors de l’actualisation de votre panier. Veuillez réessayer.');
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          if (typeof this.cart.getSectionsToRender === 'function') {
            const sections = this.cart.getSectionsToRender().map((section) => section.id);
            formData.append("sections", sections);
          }
          formData.append("sections_url", window.location.pathname);
          if (typeof this.cart.setActiveElement === 'function') {
            this.cart.setActiveElement(document.activeElement);
          }
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              document.dispatchEvent(new CustomEvent('cart:error', {
                detail: {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.errors || response.description,
                  message: response.message,
                }
              }));
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) document.dispatchEvent(new CustomEvent('cart:update', {
              detail: {
                source: "product-form",
                productVariantId: formData.get("id")
              }
            }));
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.renderCart(this.cart, response);
                  });
                },
                { once: true }
              );
              console.log("quickAddModal hide");
              quickAddModal.hide(true);
            } else {
              this.renderCart(this.cart, response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
